<script>
import MarkNotificationsAsReadMutation from '@/gql/mutations/markNotificationsAsRead.graphql'
import NotificationsQuery from '@/gql/queries/notifications.graphql'
import { mapGetters } from 'vuex'

export default {
  name: 'FinapiIssueDialog',
  computed: {
    ...mapGetters(['selectedNode']),
  },
  methods: {
    async confirmHandler() {
      await this.$apollo.mutate({
        mutation: MarkNotificationsAsReadMutation,
        variables: {
          type: 'FINAPI',
          node: this.selectedNode,
        },
        update: (
          store,
          { data: { markNotificationsAsRead: notifications } },
        ) => {
          store.writeQuery({
            query: NotificationsQuery,
            variables: {
              node: this.selectedNode,
            },
            data: { notifications },
            overwrite: true,
          })
        },
      })

      if (
        this.$router.currentRoute.fullPath ===
        this.$router.match({ name: 'settings.payment_import' })
      ) {
        return
      }

      await this.$router.push({ name: 'settings.payment_import' })
    },

    showDialog() {
      this.$refs.dialogRef.showDialog()
    },
  },
}
</script>

<template>
  <GenericConfirmationDialog
    ref="dialogRef"
    persistent
    :confirmHandler="confirmHandler"
    max-width="500px"
    titleIcon="mdi-alert-box-outline"
    title="Bankkonto verbinden"
    confirmButtonText="Bankkonto jetzt erneut verbinden"
    bodyText="Ihr Bankkonto muss erneut verbunden werden." />
</template>
